import { observer } from 'mobx-react-lite'
import controller from '../controllers/forgot.controller'
import i from '../../../translations/i'
import { Button, Input } from 'antd'
import { KeyOutlined, LockOutlined, MailOutlined, ReloadOutlined } from '@ant-design/icons'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { VerifyCode } from '../../../components/VerifyCode'
import { AuthError, AuthField, AuthHead, AuthSwitch, PasswordStrength } from '../shell/AuthShell'

const BackToLogin = () => (
    <AuthSwitch text={i.t('authShell:forgot.remembered')} link={i.t('authShell:register.login')} href="/login" />
)

// Шаг 3: новый пароль
const ForgotStepThree = observer(() => {
    const status = controller.error !== '' ? 'error' : undefined

    return(
        <>
            <AuthHead icon={<LockOutlined />} title={i.t('auth:title.changePassword')} text={i.t('auth:forgot.password')} />

            <form className="au-form" onSubmit={(e) => controller.forgot(e)}>
                <AuthError message={controller.error} />

                <AuthField label={i.t('authShell:forgot.newPassword')}>
                    <Input.Password
                        size="large"
                        autoComplete="new-password"
                        autoFocus
                        status={status}
                        prefix={<LockOutlined />}
                        placeholder={i.t('authShell:passwordPlaceholder')}
                        value={controller.data.password}
                        onChange={(e) => controller.onChangeData('password', e.target.value)}
                        required
                    />
                </AuthField>
                <PasswordStrength password={controller.data.password} />

                <AuthField label={i.t('auth:placeholder.confirmPassword')}>
                    <Input.Password
                        size="large"
                        autoComplete="new-password"
                        status={status}
                        prefix={<LockOutlined />}
                        placeholder={i.t('authShell:passwordPlaceholder')}
                        value={controller.data.passwordConfirm}
                        onChange={(e) => controller.onChangeData('passwordConfirm', e.target.value)}
                        required
                    />
                </AuthField>

                <Button size="large" type="primary" htmlType="submit" block>
                    {i.t('authShell:forgot.save')}
                </Button>
            </form>

            <BackToLogin />
        </>
    )
})

// Шаг 2: код из письма
const ForgotStepTwo = observer(() => (
    <>
        <AuthHead
            icon={<MailOutlined />}
            title={i.t('authShell:verify.title')}
            text={controller.data.login ? i.t('authShell:verify.sentTo', { email: controller.data.login }) : i.t('auth:verify.text')}
        />

        <form className="au-form" onSubmit={(e) => controller.forgot(e)}>
            <AuthError message={controller.error} />

            <div className="au-code">
                <VerifyCode onChange={(e: any) => controller.onChangeData('code', e)} value={controller.data.code} />
                <Button type="link" icon={<ReloadOutlined />} onClick={() => controller.newCode()}>
                    {i.t('auth:verify.code')}
                </Button>
            </div>

            <Button size="large" type="primary" htmlType="submit" block>
                {i.t('def:actions.continue')}
            </Button>
        </form>

        <BackToLogin />
    </>
))

// Шаг 1: почта, на которую придёт код
const ForgotStepOne = observer(() => (
    <>
        <AuthHead icon={<KeyOutlined />} title={i.t('auth:title.forgot')} text={i.t('auth:forgot.text')} />

        <form className="au-form" onSubmit={(e) => controller.forgot(e)}>
            <AuthError message={controller.error} />

            <AuthField label={i.t('auth:placeholder.email')}>
                <Input
                    size="large"
                    type="email"
                    autoComplete="email"
                    autoFocus
                    status={controller.error !== '' ? 'error' : undefined}
                    prefix={<MailOutlined />}
                    placeholder={i.t('authShell:emailPlaceholder')}
                    value={controller.data.login}
                    onChange={(e) => controller.onChangeData('login', e.target.value)}
                    required
                />
            </AuthField>

            <Button size="large" type="primary" htmlType="submit" block disabled={controller.error !== ''}>
                {i.t('authShell:forgot.send')}
            </Button>
        </form>

        <BackToLogin />
    </>
))

export const Forgot = observer(() => {

    useEffect(() => {
        controller.getStepFromSession()
    }, [])

    return (
        <>
            <Helmet>
                <title>{i.t('auth:title.forgot')}</title>
            </Helmet>
            {controller.step === 0 && <ForgotStepOne />}
            {controller.step === 1 && <ForgotStepTwo />}
            {controller.step > 1 && <ForgotStepThree />}
        </>
    )
})
